
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import {
myNumbers
} from '../../../api';
import NotData from '../../NoData/NoData.vue';
import List from './list.vue';
import MHeader from '../../Header/Header.vue';
export default {
data() {
return {
list2: ['全部', '进行中', '已揭晓'],
index: 0,
status: ["", "WORKING", "ENDING"],
page_size: "50",
page_no: "0",
data: null,
list: [],
h: ""
}
},
components: {
MHeader,
Tab,
TabItem,
Swiper,
SwiperItem,
List,
ViewBox,
NotData
},
methods: {
Ajax() {
this.$store.commit('showIsLoading');
myNumbers(`status=${this.status[this.index]}&page_size=${this.page_size}&page_no=${this.page_no}`).then(res => {
if (res.data.error_code) {
this.$router.go(-1);
console.error(res);
return;
};
this.list = res.data.data ? res.data.data : [];
})
}
},
created() {
this.Ajax();
this.h = document.documentElement.clientHeight - 44 - parseInt(document.documentElement.style.fontSize) * 0.88 + 'px';

},
watch: {
index(val) {
this.Ajax();
}
}
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/takeWine/takeWine.vue